import React from "react";
import styled from "styled-components";

import { Icon } from "@components/Icon";
import { SortingOption } from "@utils";
import { GenericFilter, GenericFilterType } from "./GenericFilter";

export interface FilterHeaderType extends GenericFilterType {
  title: string | JSX.Element;
  onSort?: (direction: SortingOption) => void;
  sorting?: SortingOption;
  customFilter?: JSX.Element;
}

const FilterBlock = styled.div<{ clickable?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  user-select: none;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
`;
const Spacer = styled.div`
  flex: 1;
`;

export const FilterHeader: React.FC<FilterHeaderType> = ({
  title,
  onSort,
  sorting,
  options,
  customFilter,
  ...props
}) => {
  const onClick = () => {
    if (onSort) {
      const newSort = !sorting ? "asc" : sorting === "asc" ? "desc" : undefined;
      onSort(newSort);
    }
  };

  return (
    <FilterBlock
      onClick={onClick}
      clickable={!!onSort}
      title={onSort ? "Sort column" : undefined}
    >
      <div>{title}</div>
      <Spacer />
      {onSort ? <Icon.Sort direction={sorting} /> : null}
      {customFilter || <GenericFilter options={options || []} {...props} />}
    </FilterBlock>
  );
};

export default FilterHeader;
